import { render, staticRenderFns } from "./ComponentsupplieDetail.vue?vue&type=template&id=5eb2a7d1&"
import script from "./ComponentsupplieDetail.vue?vue&type=script&lang=js&"
export * from "./ComponentsupplieDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports